<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.keywords" placeholder="日志关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getActionLogs">查询</el-button>
        </el-form-item>        
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="actionLogs" highlight-current-row v-loading="listLoading" style="width: 100%" @sort-change="sortchange" :height="bodyHeight-220">
      <!-- <el-table-column type="selection" width="55">
      </el-table-column> -->
      <el-table-column type="index" width="60">
      </el-table-column>
       <el-table-column prop="appCode" label="客户编码" width="120" sortable="custom">
      </el-table-column>
      <el-table-column prop="actionName" label="模块名" min-width="350" sortable="custom">
      </el-table-column>
      <el-table-column prop="logType" label="日志类型" width="120" sortable="custom" :formatter="formatLogType">
      </el-table-column>
      <el-table-column prop="eventDate" label="日志时间" width="180" sortable="custom" :formatter="formatdatetime">
      </el-table-column>
      <el-table-column prop="totalsTime" label="耗时" align="center" width="100" sortable="custom">
      </el-table-column>
      <el-table-column prop="clientType" label="客户端类型" align="center" width="160" sortable="custom">
      </el-table-column>
      <el-table-column prop="ipAddress" label="IP地址" align="center" width="160" sortable="custom">
      </el-table-column>
      <el-table-column prop="machineKey" label="机器码" width="280" sortable="custom">
      </el-table-column>      
    </el-table>
    <el-pagination layout="prev, pager, next" @current-change="pageChange" :page-size="pagesize" :total="records" style="float:right;">
    </el-pagination>   

  </section>
</template>
<style>
  .el-input-group .el-select .el-input{
    width:90px;
  }
  i.Blue {
    color:#20A0FF
  }
  i.Success {
    color:#13CE66
  }
  i.Warning {
    color:#F7BA2A
  }
  /* .el-dialog__body {
    height: 600px;
    overflow-y:auto;
  } */
</style>

<script>
export default {
  name: 'actionLogManage',
  props: ['bodyHeight'],
  data() {
    return {
      filters: {
        keywords: ''
      },
      listLoading: false,
      sortname: 'eventDate',
      sorttype: 'desc',
      pagesize: 20,
      pageno: 1,
      records: 0,
      totalpages: 0,
      tableheight: window.innerHeight - 220,
      actionLogs: [
      ]
    }
  },
  methods: {
    formatdatetime: function(row, col, value) {
      return new Date(value).Format('yyyy-MM-dd hh:mm:ss')
    },
    // 显示转换
    formatLogType: function(row, c, v) {
      if (v === 0) {
        return 'Service'
      } else if (v === 1) {
        return 'API'
      } else {
        return '未知'
      }
    },
    // 操作日志列表
    getActionLogs: function() {
      let para = {
        keywords: this.filters.keywords,
        pageno: this.pageno,
        pagesize: this.pagesize,
        sortname: this.sortname,
        sorttype: (this.sorttype === 'ascending' ? 'asc' : 'desc')
      }

      this.$ajax({
        url: 'api/ActionLog/GetActionLogs',
        method: 'get',
        data: para,
        loadingName: 'listLoading',
        success: (d, r) => {
          let { records, totalpages } = r
          this.actionLogs = d
          this.records = records
          this.totalpages = totalpages
        }
      })
    },
    pageChange: function(val) {
      this.pageno = val
      this.getActionLogs()
    },
    sortchange: function(sort) {
      this.sortname = sort.prop
      this.sorttype = sort.order
      this.getActionLogs()
    }
  },
  mounted() {
    this.getActionLogs()
    window.onresize = () => {
      return (() => {
        this.tableheight = window.innerHeight - 220
      })()
    }
  }
}
</script>